import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { HookSection } from '../components/HookSection';
import { ProblemSection } from '../components/ProblemSection';
import { FailedSolutions } from '../components/FailedSolutions';
import { MechanismSection } from '../components/MechanismSection';
import { WhatYouGet } from '../components/WhatYouGet';
import { WhoItsFor } from '../components/WhoItsFor';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <main className="min-h-screen bg-[#FAF7F2] font-sans selection:bg-[#C9A84C] selection:text-[#1B5E5E]" data-id="element-190">
      <HeroSection data-id="element-191" />
      <HookSection data-id="element-192" />
      <ProblemSection data-id="element-193" />
      <FailedSolutions data-id="element-194" />
      <MechanismSection data-id="element-195" />
      <WhatYouGet data-id="element-196" />
      <WhoItsFor data-id="element-197" />
      <CTASection data-id="element-198" />
      <Footer data-id="element-199" />
    </main>;
}